import { isValidEmail } from './welcomeEmailTemplate.js';

export const MAX_BATCH_SIZE = 50;

// One person per line, as pasted from an email or a spreadsheet: the email first, then
// optionally a name, separated by a tab, semicolon or comma. "Name <email>" works too.
export function parsePeopleText(text) {
    return String(text || '')
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => {
            const angled = line.match(/^(.*?)<([^<>]+)>\s*$/);
            if (angled) return { email: angled[2].trim(), name: angled[1].replace(/["',;]/g, '').trim() };

            const [first, ...rest] = line.split(/\t|;|,/).map((part) => part.trim());
            return { email: first, name: rest.filter(Boolean).join(' ') };
        });
}

// The problem with each row, or null. Rows are checked as the function will check them, so a
// list without problems is one the function accepts.
export function peopleProblems(people) {
    const counts = new Map();
    people.forEach((person) => {
        const key = String(person.email || '').trim().toLowerCase();
        counts.set(key, (counts.get(key) || 0) + 1);
    });

    return people.map((person) => {
        const email = String(person.email || '').trim();
        if (!email) return 'Mangler email.';
        if (!isValidEmail(email)) return 'Ikke en gyldig email.';
        if (counts.get(email.toLowerCase()) > 1) return 'Står flere gange på listen.';
        return null;
    });
}

export function batchProblem(people) {
    if (people.length === 0) return 'Tilføj mindst én person.';
    if (people.length > MAX_BATCH_SIZE) return `Højst ${MAX_BATCH_SIZE} personer ad gangen.`;
    if (peopleProblems(people).some(Boolean)) return 'Ret de markerede rækker.';
    return null;
}
